import { fmtBytes } from "@/lib/imageCompression";

/** Barre de progression native pour les uploads photo CRM (compression + envoi). */
export default function UploadProgress({ state, testId = "crm-upload-progress" }) {
  if (!state || state.phase === "done") return null;
  const pct = state.phase === "compress" ? 0 : Math.round((state.loaded / Math.max(1, state.size)) * 100);
  const gain = state.before > 0 ? Math.round((1 - state.after / state.before) * 100) : 0;
  return (
    <div className="rounded-lg border border-white/10 bg-[#181818] px-3 py-2 space-y-1" data-testid={testId} style={{ fontFamily: "Tahoma, sans-serif" }}>
      <div className="flex items-center justify-between text-[10.5px]" style={{ color: "#c9c9d1" }}>
        <span className="truncate" style={{ maxWidth: "60%" }} data-testid={`${testId}-label`}>
          {state.phase === "compress" ? "Compression" : "Envoi"} · {state.name} ({state.index + 1}/{state.total})
        </span>
        <span style={{ color: "#8a8a8f" }} data-testid={`${testId}-bytes`}>{state.phase === "upload" ? `${fmtBytes(state.loaded)} / ${fmtBytes(state.size)}` : fmtBytes(state.size)}</span>
      </div>
      <progress value={pct} max={100} className="w-full h-1.5 [&::-webkit-progress-bar]:bg-[#2a2a2e] [&::-webkit-progress-bar]:rounded [&::-webkit-progress-value]:bg-[#6D3FBF] [&::-webkit-progress-value]:rounded [&::-moz-progress-bar]:bg-[#6D3FBF]" data-testid={`${testId}-bar`} />
      {state.before > 0 && state.after < state.before && (
        <div className="text-[10px]" style={{ color: "#4ade80" }} data-testid={`${testId}-gain`}>
          {fmtBytes(state.before)} → {fmtBytes(state.after)} · −{gain} %
        </div>
      )}
    </div>
  );
}
